import * as React from "react"
import {
  Text,
  HStack,
  Image,
  useColorMode,
} from "@chakra-ui/react"
import { brandConfig } from "./brandConfig"

// Main Logo component — reads from brandConfig
export const Logo = React.forwardRef<HTMLDivElement, any>((props, ref) => {
  const { colorMode } = useColorMode();
  const logo = brandConfig.logo;
  const siteName = brandConfig.siteName || "My Business";
  const primaryColor = brandConfig.colors?.primary || "#0051D0";

  // If logo.src is a URL (starts with http or /), show an image
  const isImageLogo = logo?.src && (logo.src.startsWith('http') || logo.src.startsWith('/'));

  return (
    <HStack
      ref={ref}
      spacing={2}
      align="center"
      {...props}
    >
      {isImageLogo ? (
        <Image
          src={logo.src}
          alt={logo.alt || siteName}
          height={{ base: "28px", md: "32px" }}
          objectFit="contain"
        />
      ) : logo?.src ? (
        <Text fontSize={{ base: "xl", md: "2xl" }}>
          {logo.src}
        </Text>
      ) : null}
      <Text
        fontSize={{ base: "lg", md: "xl" }}
        fontWeight="700"
        color={colorMode === 'light' ? "#1A202C" : "white"}
        letterSpacing="-0.03em"
        whiteSpace="nowrap"
        fontFamily="Geist, -apple-system, BlinkMacSystemFont, 'SF Pro Display', 'Segoe UI', system-ui, sans-serif"
      >
        {siteName}
      </Text>
    </HStack>
  )
})

Logo.displayName = 'Logo'

export default Logo;
